import styled from 'styled-components';
import { Container as ContainerBase, Typography } from '@material-ui/core';

import Colors from '~/styles/colors';

interface SpacerProps {
  flex?: number;
}

interface LabelProps {
  fontWeight?: string;
  marginTop?: number;
  marginLeft?: number;
  fontSize?: number;
  textAlign?: string;
}

export const Container = styled(ContainerBase)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: space-evenly;
  background-color: ${Colors.lightGreyNew};
`;

export const ViewLabel = styled.div`
  align-items: center;
`;

export const Label = styled(Typography)<LabelProps>`
  color: ${Colors.primary};
  font-weight: ${props => props.fontWeight ?? 'normal'};
  margin-top: ${props => props.marginTop ?? 0}px;
  margin-left: ${props => props.marginLeft ?? 20}px;
  margin-right: ${props => props.marginLeft ?? 20}px;
  font-size: ${props => props.fontSize ?? 14}px;
  text-align: ${props => props.textAlign ?? 'center'};
`;

export const Spacer = styled.div<SpacerProps>`
  display: flex;
  flex: ${props => props.flex ?? 1};
`;

export const Camera = styled.img`
  width: 152px;
  height: 152px;
`;
